import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Star } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export const ReviewsSection = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews")
      .then((r) => setData(r.data))
      .catch(() => setData({ published: false, reviews: [] }));
  }, []);

  // La propietaria publica la sección desde el panel; hasta entonces no se muestra nada
  if (!data || !data.published || !data.reviews.length) return null;

  return (
    <section data-testid="reviews-section" className="bg-sand py-24 px-6 border-t border-line">
      <div className="max-w-[1100px] mx-auto">
        <p className="text-[10px] uppercase tracking-[0.3em] text-terracotta mb-3">{t("reviews.kicker")}</p>
        <h2 className="font-serif text-4xl sm:text-5xl text-ink mb-3">{t("reviews.title")}</h2>
        <p className="text-base text-ink/55 mb-12 max-w-[520px]">{t("reviews.sub")}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {data.reviews.map((r, i) => (
            <figure key={r.id} data-testid={`review-card-${i}`} className="bg-white border border-line p-6 flex flex-col">
              <div className="flex gap-0.5 text-[#C8A97E] mb-4">
                {Array.from({ length: r.rating }).map((_, s) => (
                  <Star key={s} size={14} weight="fill" />
                ))}
              </div>
              <blockquote className="text-sm leading-relaxed text-ink/75 flex-1">“{r.text}”</blockquote>
              <figcaption className="mt-5 text-[11px] uppercase tracking-[0.18em] text-ink/45">
                {r.author} · {r.apartment_name}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
